import request from '@/utils/request';

/**
 * EBK账号是否绑定
 * @param params
 * @returns {AxiosPromise}
 */
export function ebkOrderCheckBind(params) {
  return request({
    url: `/channel-agent/ebk/acount/checkBind`,
    method: 'get',
    params,
  });
}

/**
 * EBK订单列表
 * @param params
 * @returns {AxiosPromise}
 */
export function ebkOrderList(params) {
  return request({
    url: '/channel-agent/eb/order/pms/ebkOrders',
    method: 'POST',
    data: params,
  });
}

/**
 * EBK订单列表
 * @param params
 * @returns {AxiosPromise}
 */
export function bindAccounts(params) {
  return
}

/**
 * EBK订单详情
 * @param mtOrderId
 * @returns {AxiosPromise}
 */
export function ebkOrderDetail(mtOrderId) {
  return request({
    url: `/channel-agent/eb/order/pms/ebkOrdersDetail`,
    method: 'get',
    params: { mtOrderId },
  });
}

/**
 * EBK订单可接单数量
 * @param params
 * @returns {AxiosPromise}
 */
export function ebkOrderDrawerMessage(params) {
  return request({
    url: `/channel-agent/eb/order/pms/ebkOrdersDrawer`,
    method: 'get',
    params,
  });
}

/**
 * EBK账号设置
 * @param params
 * @returns {AxiosPromise}
 */
export function ebkAccountSetting(params) {
  return request({
    // eslint-disable-next-line no-undef
    url: `${process.env.VUE_APP_PHP_PMS_URL}/pc/ebkorders/accountSetting`,
    method: 'post',
    data: params,
  });
}

/**
 * EBK账号详情
 * @param account
 * @param params
 * @returns {AxiosPromise}
 */
export function ebkAccountDetail(account, params) {
  return request({
    // eslint-disable-next-line no-undef
    url: `${process.env.VUE_APP_PHP_PMS_URL}/pc/ebkorders/accounts/${account}`,
    method: 'get',
    params,
  });
}

/**
 * EBK账号列表
 * @param params
 * @returns {AxiosPromise}
 */
export function ebkAccountList(params) {
  return request({
    url: '/channel-agent/ebk/acount/list',
    method: 'GET',
    data: params,
  });
}

/**
 * EBK账号解绑
 * @param params
 * @returns {AxiosPromise}
 */
export function ebkAccountUnBind(params) {
  return request({
    url: `/channel-agent/ebk/acount/unbind`,
    method: 'GET',
    params,
  });
}

/**
 * EBK账号绑定
 * @param params
 * @returns {AxiosPromise}
 */
export function ebkAccountBind(params) {
  return request({
    url: `/channel-agent/ebk/acount/bind`,
    method: 'POST',
    data: params,
  });
}

/**
 * 获取同步时间
 * @param params
 * @returns {AxiosPromise}
 */
export function getSyncStatus(params) {
  return request({
    url: `/channel-agent/eb/sync/status`,
    method: 'GET',
    params,
  });
}

/**
 * 查询房型列表
 * @param params
 * @returns {AxiosPromise}
 */
export function getRoomTypeList(params) {
  return request({
    url: `/channel-agent/eb/room/mapping/query`,
    method: 'GET',
    params,
  });
}

/**
 * EB订单消息 - 确认接单
 * @param params
 * @returns {AxiosPromise}
 */
export function confirmOrder(params) {
  return request({
    url: `/channel-agent/eb/order/pms/hourSecondCreate`,
    method: 'GET',
    params,
  });
}

// 房型绑定/解绑接口

export function bindroom(data) {
  return request({
    url: `/channel-agent/eb/bind/room`,
    method: 'post',
    data,
  });
}

// 查询轻住房型
export function roomQuery(params) {
  return request({
    url: `/channel-agent/eb/qz/room/query`,
    method: 'GET',
    params,
  });
}

// 查询轻住产品
export function productQuery(params) {
  return request({
    url: `/channel-agent/eb/qz/product/query`,
    method: 'GET',
    params,
  });
}

//数据同步
export function roomSync(params) {
  return request({
    url: `/channel-agent/eb/room/sync`,
    method: 'get',
    params,
  });
}

// 获取产品数据
export function productList(params) {
  return request({
    url: `/channel-agent/eb/product/mapping/query`,
    method: 'get',
    params,
  });
}


// 产品绑定/解绑接口

export function bindProduct(data) {
  return request({
    url: `/channel-agent/eb/bind/product`,
    method: 'post',
    data,
  });
}
//ebk搬单自检补录
export function ebkOrderMoveCheck(params) {
  return request({
    url: `/channel-agent/eb/order/pms/ebMove/check`,
    method: 'get',
    params,
  });
}
